import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import TablesOverview from './components/TablesOverview';
import TableDetail from './components/TableDetail';
import { initializeBtInterfaces } from './interfaces/BtInterfaces';
import { LanguageProvider } from './contexts/LanguageContext';
import { CustomThemeProvider } from './contexts/ThemeContext';

function App() {
  useEffect(() => {
    // Initialize BtApp and BtDevice interfaces
    initializeBtInterfaces();

    // Add viewport meta tag for mobile
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) {
      viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no');
    }
  }, []);

  return (
    <LanguageProvider>
      <CustomThemeProvider>
        <CssBaseline />
        <Router>
          <Routes>
            <Route path="/" element={<TablesOverview />} />
            <Route path="/table/:tableId" element={<TableDetail />} />
          </Routes>
        </Router>
      </CustomThemeProvider>
    </LanguageProvider>
  );
}

export default App;